import { ScreenSize } from "../../common/index"
import { qweIsEmpty, mockFormSubmit, qweLetterGuid } from "../../common/commonHelper"
import { ElMessage,ElLoading } from "element-plus";
import dayjs from "../../utils/dayjs"
import { getFlowNodes, newContentItem, createContentItem, editContentItem, updateContentItem, workFlowExe } from "../../apis/httpHelper"
import { loader } from "../../utils/loader"
import { FormEvent } from "."
import { ResponseCode } from "../../common/constant";
import { Check } from '@element-plus/icons-vue'
import { markRaw, computed } from "vue"
import { qweEquals, qweGuid } from "../../common/commonHelper"
let phoneScreen = [ScreenSize.xs, ScreenSize.sm]

export default {
    name:"qweBaseForm",
    provide:function(){
        return {
            validateForm:this.validateForm,
            buildFormContext: this.buildContext,
            forceDisplay:computed(()=>this.formEditState),
            fullScreen:phoneScreen.includes(this.$store.state.screenInfo.screenSize),
            initState: computed(()=>this.initState),
            errorEventBus : computed(()=> this.errorEventBus),
            errorComponentPath: computed(()=> this.errorFieldPath)
        }
    },

    props:{
        //prop模式使用，是否强制显示模式
        display:{
            type: Boolean,
            default:function () {
                return false;
            },
        },

        //prop模式使用，就是publish按钮的显示，即表单操作
        operatorName:{
            type: String,
            default:function () {
                return "";
            },
        },

        //是否是prop模式
        isPropMode:{
            type: Boolean,
            default:function () {
                return false;
            },
        },

        beforeSubmit:{
            type:Function,
        },

        //暂时不知道啥用处
        toRedirect:{
            type:Boolean,
            default:function () {
                return true;
            },
        },

        //prop模式使用，传递其他数据
        propDatas: Object,

        //当前表单是创建还是更新
        operation: {
            type: String,
            default: function () {
                return "Create";
            },
            validator: function (value) {
                return ['Create', 'Edit'].indexOf(value) !== -1;
            }
        },
        //创建模式下，传递的参数
        passingParameter: {
            type: Array,
            default: function () {
                return new Array();
            }
        },
        contentType: String,
        contentItemId: String,
        flowCurrentNodeId: String,
        nodeIds: {
            type: Array,
            default: function () {
                return new Array();
            }
        },
        //是否显示表单头部
        isShowHead: {
            type: Boolean,
            default: false
        },
        
        showButton:{
            type: Boolean,
            default: true
        },
        
        htmlPrefix:{
            type: String,
            default: function () {
                return "";
            }
        }
    },

    emits:[
        FormEvent.initForm,
        FormEvent.submit,
        FormEvent.draft,
        FormEvent.reCall,
        FormEvent.backOff,
        FormEvent.backOffToLast,
        FormEvent.end,
        FormEvent.handOver,
        FormEvent.operatorForm
    ],

    data:function(){
        return {
            initState:0,
            initLoading:false,

            wantScroller:"",
            formData: {},
            action:"",
            updateUrl: "",
            checkInParameters:{},

            qweParent:{},

            refForm:"abc",
            formItemPosition:"right",

            headName:"",
            flowNodes: [],

            requestData: {},
            formBodyHeight:"",

            requestContentType: "",
            requestOperation: "Create",
            requestContentItemId: "",
            requestCurrentNodeId:"",
            requestNodeIds:[],

            contentDefinition: [],
            orginalLayout:[],
            errorFieldPath:[],
            errorEventBus:0,

            commomButtons: {
                "Publish": {
                    "Switch": false,
                    "ButtonName": "提交"
                },
                "Draft": {
                    "Switch": false,
                    "ButtonName": "暂存"
                },
                "Preview": {
                    "Switch": false,
                    "ButtonName": "预览"
                },
                "PreviewList": {
                    "Switch": false,
                    "ButtonName": "预览",
                    "PrintList": []
                },
                "Print": {
                    "Switch": false,
                    "ButtonName": "打印"
                },
                "PrintList": {
                    "Switch": false,
                    "ButtonName": "打印",
                    "PrintList":[]
                },
                "ReCall": {
                    "Switch": false,
                    "ButtonName": "撤回"
                },
                "BackOff": {
                    "Switch": false,
                    "ButtonName": "回退"
                },
                "HandOver": {
                    "Switch": false,
                    "ButtonName": "转交"
                },
                "End": {
                    "Switch": false,
                    "ButtonName": "结束流程"
                }
            },

            previewList:[],
            printList:[],

            buttonLoading:{
                Submit:false,
                Draft:false,
                HandOver:false,
                BackOff:false,
                End:false,
                ReCall:false
            },
            
            isFlow: false,
            flowVersionId: "",

            canReCall: false,
            

            //转交
            handOverValue: {},
            handOverOptions: [],
            handOverModalDisplay: false,

            //回退
            backOffValue: "",
            backOffOptions: [],
            backOffModalDisplay: false,

            isNextNodePic: false,
            isForceDisplay: false,

            //评论相关
            switchComment: false,
            comment: "",
            allowNodeHasComment: false,
            isShowCommentList: false,

            buttons: [],
            checkIn: [],

            //前端缓存
            frontEndSaveValue: false,
            saveLocal: { "Switch": false },

            //前端事件
            frontEndEvents:[],
            frontEndFields: [],

            //前端显隐
            frontEndShow: [],
            frontEndShowRelyFieldNames: [],
            frontEndShowFields:[],

            formDefinition: {},
            orginalDisplay: {},
            
            layout:[],

            jsList:[],
            cssList:[],
            labelSetting:{ "Auto": true, "Width" : 0 },
            labelWitdh:""
        }
    },

    computed:{
        formEditState:function(){
            return this.isForceDisplay;
        },

        buttonRequestState:function(){
            return Object.values(this.buttonLoading).findIndex(x=> x) > -1;
        },

        isCreateMode:function(){
            return this.requestOperation === "Create";
        },

        formBodyStyle:function(){
            return {
                height:this.formBodyHeight + "px"
            }
        },

        buttonShow:function(){
            let editShow = !this.isForceDisplay && (
                this.commomButtons.Publish.Switch 
                || this.commomButtons.Draft.Switch 
                || this.commomButtons.HandOver.Switch 
                || this.commomButtons.BackOff.Switch
                || this.commomButtons.End.Switch
                || this.previewList.length > 0);
            let displayShow = this.isForceDisplay && (this.commomButtons.ReCall.Switch || this.printList.length > 0);
            return editShow || displayShow;
        }
    },

    created: function () {
        this.refForm = qweLetterGuid(10);
        this.initQweFormItem();
        let self = this;
        
        this.$watch(
            ()=> this.operation + this.contentItemId + this.contentType + this.flowCurrentNodeId,
            (newValue,oldValue)=>{
                self.initQweFormItem();
            }
        );

        this.$watch(
            ()=> this.propDatas,
            (newValue,oldValue)=>{
                self.initQweFormItem();
            }
        );
    },

    beforeUnmount:function(){
        (this.cssList ||[]).forEach(x=>{
            loader.uninstallCss(x)
        });
    },

    methods:{
        //初始化表单
        initQweFormItem:function(){
            this.initLoading = true;
            this.requestOperation = this.operation;
            this.requestContentItemId = this.contentItemId;
            this.requestContentType = this.contentType;
            
            if (this.isPropMode) {
                this.localInit();
            }
            else {
                this.remoteInit(true);
            }
        },

        initFieldsRely:function(fieldTypes){
            
        },

        //本地初始化
        localInit:function(){
            if (!this.propDatas.hasOwnProperty("ContentTypeDefinition")) {
                console.log('初始化失败,当前为本地初始化，无定义参数');
                this.emitParent(FormEvent.initForm, ResponseCode.NotFound);
                return;
            }

            this.qweParent = this.propDatas.ParentData;
            this.buildForm(this.propDatas);
            this.commomButtons.Publish.Switch = true;
            this.initLoading = false;
        },

        //远程初始化
        remoteInit: function (init, currentNodeId) {
            if (this.isCreateMode) {
                if (qweIsEmpty(this.contentType)) {
                    console.log('系统出现错误，当前处于新增模式并且无ContentType参数');
                    this.initLoading = false;
                    this.emitParent(FormEvent.initForm, ResponseCode.NotFound);
                    return;
                }
                
                if (this.passingParameter.length > 0) {
                    this.passingParameter.forEach(x => {
                        let key = `${this.contentType}.${x.Name}.Value`;
                        let value = x.Value;
                        if (value instanceof Array) {
                            value = JSON.stringify(value);
                        }
                        else if (value instanceof Date) {
                            value =  dayjs(value).format("YYYY-MM-DDTHH:mm:ss.SSS");
                        }
                        this.requestData[key] = value;
                    });
                }
            }

            else{
                if (qweIsEmpty(this.requestContentItemId)) {
                    ElMessage.error('系统出现错误，当前处于编辑模式并且无contentItemId参数');
                    this.initLoading = false;
                    this.emitParent(FormEvent.initForm, ResponseCode.NotFound);
                    return;
                }
                if (init) {
                    this.requestCurrentNodeId = this.flowCurrentNodeId;
                    this.requestNodeIds = this.nodeIds;
                }
                else {
                    if (currentNodeId !== null || currentNodeId !== undefined) {
                        this.requestCurrentNodeId = currentNodeId;
                    }
                    else {
                        this.requestCurrentNodeId = "";
                    }
                }
            }

            let handlerContentItem;

            if(this.isCreateMode){
                handlerContentItem = newContentItem(this.requestContentType,this.requestData)
            }
            else{
                handlerContentItem = editContentItem(this.requestContentItemId,this.requestCurrentNodeId,this.requestNodeIds)
            }
            handlerContentItem
                .then(data=>{
                    this.buildForm(data.Result, init);
                }).catch(e=>{
                    console.log(e);
                    this.emitParent(FormEvent.initForm, e.Code, e);
                }).finally(()=>{
                    this.initLoading = false;
                });
        },

        //构建表单
        buildForm:function(formBuilder, init){
            if(init){
                this.jsList = formBuilder.JsList || [];
                loader.loadScriptConcurrent(this.jsList)
                    .then(x=>{
                        this.buildQweForm(formBuilder, init);
                    }).catch(x=>{
                        this.buildQweForm(formBuilder, init);
                        console.error("有依赖文件出现异常", x)
                    });
            }
            else{
                this.buildQweForm(formBuilder, init);
            }
        },

        //响应构建表单
        buildQweForm:function(formBuilder, init){
            //传递一些当前表单不存在的校验数据
            this.checkInParameters = formBuilder?.CheckInParameters ?? this.checkInParameters;
            this.labelSetting = formBuilder?.LabelSetting ?? this.labelSetting;
            this.labelWitdh = this.labelSetting.Auto ? "auto" : this.labelSetting.Width + "px";
            


            this.isFlow = formBuilder?.IsFlow ?? this.isFlow;
            this.requestContentType = formBuilder?.ContentType ?? this.requestContentType;
            this.isForceDisplay = (this.display ? true : formBuilder?.IsDisplay) ?? this.isForceDisplay;
            this.commomButtons = formBuilder?.CommomButtons ?? this.commomButtons;
            if(this.isFlow){
                this.requestCurrentNodeId = formBuilder.FlowCurrentNodeId;
                this.flowVersionId = formBuilder?.FlowVersionId ?? this.flowVersionId;
                this.isNextNodePic = formBuilder?.IsNextNodePIC ?? this.isNextNodePic;
                this.canReCall = formBuilder?.CanReCall ?? this.canReCall;
                this.flowNodes = formBuilder?.FlowNodes ?? this.flowNodes;
                this.switchComment = formBuilder?.SwitchComment ?? this.switchComment;
                this.allowNodeHasComment = formBuilder?.IsAllComment ?? this.switchComment;
                if (this.commomButtons.BackOff.Switch && !this.commomButtons.BackOff.IsDirect) {
                    getFlowNodes(this.flowVersionId)
                    .then(x=>{
                        this.backOffOptions = x.Result.filter(y=> this.commomButtons.BackOff.NodeToBeSelecetd.includes(y.value));
                    })
                }
            }
            
            if(!formBuilder.hasOwnProperty("Data")){
                formBuilder.Data = {};
            }

            if(this.isPropMode){
                formBuilder.ContentTypeDefinition.forEach(x => {
                    if(!formBuilder.Data.hasOwnProperty(x.Name)){
                        formBuilder.Data[x.Name] = null;
                    }
                    this.formData[x.Name] = formBuilder.Data[x.Name];
                });
                this.formData["QweGuid"] = formBuilder.Data["QweGuid"];
            }
            else{
                if(init){
                    formBuilder.ContentTypeDefinition.forEach(x => {
                        let value = formBuilder.Data[x.Name]?.Value ?? null;
                        if(x.FieldDefinition.Name == "SubFormField"){
                            (value || []).forEach(val=>{
                                if(!val.hasOwnProperty("QweGuid")){
                                    val.QweGuid = qweGuid(26);
                                }
                            })
                        }
                        this.formData[x.Name] = value;
                    });
                }
                else{
                    // formBuilder.ContentTypeDefinition.forEach(x => {
                    //     let value = formBuilder.Data[x.Name]?.Value ?? null;
                    //     if(FieldReferenceType.includes(x.FieldDefinition.Name)){
                    //         this.initFieldData(x.FieldDefinition.Name, x.Name, this.formData, value);
                    //     }
                    //     else{
                    //         this.formData[x.Name] = value;
                    //     }
                    // });
                }
            }

            if(formBuilder.ComputeFlowDefinition){
                this.formDefinition = this.buildFormDefinition(formBuilder.ContentTypeDefinition);
            }
            else{
                formBuilder.ContentTypeDefinition = formBuilder.ContentTypeDefinition.filter(y => {
                    let index = formBuilder.FlowDefinition.findIndex(flow => flow.Name === y.Name);
                    if (index === -1) {
                        return false;
                    }
                    return !formBuilder.FlowDefinition[index].IsHidden;
                });
                
                formBuilder.FlowDefinition.forEach(x=>{
                    this.formDefinition[x.Name] = x;
                })
            }


            this.contentDefinition = formBuilder.ContentTypeDefinition;
            let fieldTypes = Array.from(new Set(formBuilder.ContentTypeDefinition.map(x=>x.FieldDefinition.Name)));
            this.initFieldsRely(fieldTypes);

            this.dataContentType = formBuilder.ContentType;

            this.headName = formBuilder?.CurrentDisplayName ?? this.headName;
            this.checkIn = formBuilder?.CheckIn ?? this.checkIn;
            this.saveLocal = formBuilder?.SaveLocal ?? this.saveLocal;

            if (this.saveLocal.Switch) {
                let GetItem = localStorage.getItem(this.dataContentType + this.requestCurrentNodeId);
                if (GetItem !== null) {
                    let data = JSON.parse(GetItem);
                    this.saveLocal.FieldNames.forEach(x => {
                        this.formData[x] = data[x];
                    });
                }
            }

            this.orginalDisplay = this.buildOrginalDisplay(this.formDefinition);
            
            let layoutString = formBuilder?.Layout ?? "";
            if (!qweIsEmpty(layoutString)) {

                this.orginalLayout = JSON.parse(layoutString);

                let layout = JSON.parse(layoutString);
                let layoutElements = new Array();
                layout = layout.filter(x => (x.FieldDefinition.Name === "Custom" ? this.contentDefinition.findIndex(y => y.Name === x.Name) > -1 : true));
                layout.forEach((x, index) => {
                    if (x.FieldDefinition.Name === "Custom") {
                        layoutElements.push(this.contentDefinition.find(y => y.Name === x.Name));
                    }
                    else {
                        let grandson = this.handlerLayout(x);
                        if (grandson !== null) {
                            layoutElements.push(grandson);
                        }
                    }
                });
                this.layout = layoutElements;
            }
            else {
                this.layout = this.contentDefinition;
            }

            //处理前端事件
            (formBuilder.FrontEndEventSettings || []).forEach(x => {
                x.SendDataFunc = new Function("Context", "Content", "self", x.SendData);
                x.CanExecuteFunc = new Function("Context", "Content", "self", x.CanExecute);
                x.SuccessFunc = new Function("Context", "Content", "Response", "self", x.JsString);
                x.AcceptData.forEach(acceptdata => {
                    acceptdata.dataFunc = new Function("Context", "Content", "Response", "self",  acceptdata.Value);
                });
                this.$watch("formData."+ x.FieldTigger,function(oldValue,newValue){
                    this.frontEndEventTrigger(x, x.FieldTigger,oldValue)
                });
            });

            
            this.handlerPrintButton();

            this.cssList = formBuilder.CssList || [];
            this.handlerCss(this.cssList);

            //this.handlerFormHeight();
            
            this.emitParent(FormEvent.initForm, ResponseCode.Success, formBuilder);
        },

        //计算表单高度
        handlerFormHeight:function(){
            let allForm = this.$el?.parentElement.firstElementChild.clientHeight ?? 199;
            let headerHeight = this.isShowHead ? 40 : 0;
            let footButtonHeight = this.buttonShow ? 40 : 0;
            let footSaveLocalHeight = this.saveLocal.Switch ? 40 : 0;
            this.formBodyHeight = allForm - headerHeight - footButtonHeight - footSaveLocalHeight - 1;
        },

        //初始化打印按钮
        handlerPrintButton:function(){
            this.previewList = this.commomButtons.PreviewList.PrintList.filter(x=>x.Switch);
            this.printList = this.commomButtons.PrintList.PrintList.filter(x=>x.Switch);

            this.previewList.forEach(priviewButton=> {
                priviewButton.showState = false;
                priviewButton.showFunc = new Function("Context","Content", priviewButton.ShowRole);

                (priviewButton.RoleRelys || []).forEach(field=>{
                    this.$watch("formData." + field,function(){
                        let context = this.buildContext();
                        priviewButton.showState = priviewButton.showFunc(context, context.Content);
                    });
                });
                let context1 = this.buildContext();
                priviewButton.showState = priviewButton.showFunc(context1, context1.Content);
                
            });

            this.printList.forEach(x=> {
                x.showState = false;
                x.showFunc = new Function("Context","Content", x.ShowRole);
                (x.RoleRelys || []).forEach(field=>{
                    this.$watch("formData." + field,function(){
                        let context = this.buildContext();
                        x.showState = x.showFunc(context, context.Content);
                    })
                });
                let context1 = this.buildContext();
                x.showState = x.showFunc(context1, context1.Content);
            });
        },

        //根据字段定义构建表单字段属性
        buildFormDefinition: function(contentDefinition){
            let formDefinition = {};
            contentDefinition.forEach(x => {
                let defi = {};
                defi.Name = x.Name;
                defi.IsDisplay = x.Settings.FieldCommonSetting.IsDisplay;
                defi.IsEdit = x.Settings.FieldCommonSetting.IsEdit;
                defi.IsRequired = x.Settings.FieldCommonSetting.Required;
                if (x.FieldDefinition.Name === "SubFormField") {
                    defi.SubformCreate = x.Settings.SubFormFieldSetting.SubformCreate;
                    defi.SubformDelete = x.Settings.SubFormFieldSetting.SubformDelete;
                    defi.SubformEdit = x.Settings.SubFormFieldSetting.SubformEdit;
                    let subFormFields = JSON.parse(x.Settings.SubFormFieldSetting.FieldsString);
                    let subFormFieldSetting = this.buildFormDefinition(subFormFields);
                    subFormFields.forEach(sub => {
                        let subdefi = {};
                        subdefi.Name = sub.Name;
                        subdefi.IsDisplay = sub.Settings.FieldCommonSetting.IsDisplay;
                        subdefi.IsEdit = sub.Settings.FieldCommonSetting.IsEdit;
                        subdefi.IsRequired = sub.Settings.FieldCommonSetting.Required;
                        formDefinition[sub.Name] = subdefi;
                    });
                    defi.SubformSettings = Object.values(subFormFieldSetting);
                }
                else if (x.FieldDefinition.Name === "LinkQueryField") {
                    defi.SubformCreate = x.Settings.LinkQueryFieldSetting.SubformCreate;
                    defi.SubformDelete = x.Settings.LinkQueryFieldSetting.SubformDelete;
                    defi.SubformEdit = x.Settings.LinkQueryFieldSetting.SubformEdit;
                }
                formDefinition[x.Name] = defi;
            });
            return formDefinition;
        },

        //处理记录原始显示
        buildOrginalDisplay:function(formDefinition){
            let orginalDisplay = {};
            for (let key in formDefinition) {
                orginalDisplay[key] = formDefinition[key].IsDisplay;
            }
            return orginalDisplay;
        },

        //更改流程节点显示
        changeFlowNode:function(nodeId){
            this.remoteInit(false, nodeId);
        },

        //处理layout
        handlerLayout:function(item){
            if(item.FieldDefinition.Name === "qweCard"){
                //判断是否有无效的子数据
                item.Settings.Components = item.Settings.Components.filter(x => (x.FieldDefinition.Name === "Custom" ? this.contentDefinition.findIndex(y => y.Name === x.Name) > -1 : true));
                let components = new Array();

                item.Settings.Components.forEach((x, index) => {
                    if (x.FieldDefinition.Name === "Custom") {
                        components.push(this.contentDefinition.find(y => y.Name === x.Name));
                    }
                    else{
                        let grandson = this.handlerLayout(x);
                        if (grandson !== null) {
                            components.push(grandson);
                        }
                    }
                });
                item.Settings.Components = components;
                if (components.length > 0) {
                    return item;
                }
                else {
                    return null;
                }
            }
            else{
                item.Settings.Childrens.forEach(Child => {
                    //判断是否有无效的子数据
                    Child.Components = Child.Components.filter(x => (x.FieldDefinition.Name === "Custom" ? this.contentDefinition.findIndex(y => y.Name === x.Name) > -1 : true));
                    let components = new Array();
    
                    //对子数据进行循环处理
                    Child.Components.forEach((x, index) => {
                        if (x.FieldDefinition.Name === "Custom") {
                            components.push(this.contentDefinition.find(y => y.Name === x.Name));
                        }
                        else{
                            let grandson = this.handlerLayout(x);
                            if (grandson !== null) {
                                components.push(grandson);
                            }
                        }
                    });
                    Child.Components = components;
                });
                let booltag = false;
                item.Settings.Childrens.forEach(x => { booltag = (booltag || x.Components.length > 0); });
                if (booltag) {
                    return item;
                }
                else {
                    return null;
                }
            }
            
            
        },

        //前端事件触发初始化
        frontEndEventTrigger: function (frontEndEvent, oldValue) {
            let context = this.buildContext();
            if (frontEndEvent.CanExecuteFunc(context,this.formData)) {
                let frontEndEventloading = ElLoading.service({
                    lock: true,
                    text: frontEndEvent.Notice
                });
                let requestData = frontEndEvent.SendDataFunc(context, this.formData);

                workFlowExe(frontEndEvent.Url, requestData)
                .then(response =>{
                    frontEndEventloading.close();
                    response = response.body;
                    frontEndEvent.AcceptData.forEach(x => {
                        this.formData[x.FieldName] = x.dataFunc(context, this.formData, response);
                    });
                    frontEndEvent.SuccessFunc(context, this.formData, response, this);
                }).catch(x=>{
                    console.log(e);
                    frontEndEventloading.close();
                    this.formData[frontEndEvent.FieldTigger] = oldValue;
                });
            }
        },

        //加载css
        handlerCss:function(cssList){
            cssList.forEach(x=>{
                loader.loadCss(x);
            })
        },

        //向父组件发送事件
        emitParent:function(operator, code, payload){
            switch (operator){
                case FormEvent.initForm:
                    this.$emit(FormEvent.initForm, code, payload);
                    return;
                case FormEvent.submit:
                    this.$emit(FormEvent.submit, code, payload);
                    break;
                case FormEvent.draft:
                    this.$emit(FormEvent.draft, code, payload);
                    break;
                case FormEvent.reCall:
                    this.$emit(FormEvent.reCall, code, payload);
                    break;
                case FormEvent.handOver:
                    this.$emit(FormEvent.handOver, code, payload);
                    break;
                case FormEvent.backOff:
                    this.$emit(FormEvent.backOff, code, payload);
                    break;
                case FormEvent.backOffToLast:
                    this.$emit(FormEvent.backOffToLast, code, payload);
                    break;
                case FormEvent.end:
                    this.$emit(FormEvent.end, code, payload);
                    break;
                default:
                    break;
            }
            this.$emit(FormEvent.operatorForm, operator, code, payload)
        },

        //校验数据格式
        validateForm:function(cb){
            let formInstance = this.$refs.refForm;
            formInstance.validate((valid, errorFields) => {
                cb(valid, errorFields);
            });
        },

        //提交数据
        publishForm:function(){
            let operater = FormEvent.submit;
            this.buttonLoading[operater] = true;
            let self = this;
            let formInstance = this.$refs.refForm;
            formInstance.validate((valid, errorFields) => {
                if (valid) {
                    //当前表单自带的校验
                    let defaultCheckResult = self.checkInResult();
                    if(defaultCheckResult){
                        self.beforeSubmitHook(operater)
                            .then(x=> {
                                if (self.isPropMode) {
                                    self.emitParent(operater, ResponseCode.Success, self.formData);
                                    self.buttonLoading[operater] = false;
                                }
                                else{
                                    self.remoteSubmit(operater)
                                        .then(x=>{
                                            let operatorName = self.operatorName;
                                            if(qweIsEmpty(self.operatorName)){
                                                operatorName = "提交";
                                            }

                                            if(x.Code == ResponseCode.Success){
                                                let alertOption = {
                                                    "customClass":"QweSuccessMessage",
                                                    "icon": markRaw(Check),
                                                    "message":operatorName + "成功"
                                                };
                                                if(!self.$store.state.isPhone){
                                                    alertOption = {
                                                        "message":operatorName + "成功"
                                                    }
                                                }
                                                ElMessage.success(alertOption);
                                            }
                                            if(x.Code == ResponseCode.SuccessAndWarn){
                                                ElMessage.warning(operatorName + "成功，但系统操作遇到一些可以忽略的错误");
                                            }
                                            //前端缓存
                                            if(self.saveLocal.Switch){
                                                if(self.frontEndSaveValue){
                                                    let data = {};
                                                    self.saveLocal.FieldNames.forEach(x => {
                                                        data[x] = self.formData[x];
                                                    });
                                                    localStorage.setItem(self.dataContentType + self.requestCurrentNodeId, JSON.stringify(data));
                                                }
                                                else{
                                                    localStorage.removeItem(self.dataContentType + self.requestCurrentNodeId);
                                                }
                                            }
                                            let payload = x.Result;
                                            self.buttonLoading[operater] = false;
                                            self.requestContentItemId = payload.ContentItemId;
                                            if (self.commomButtons.Print.Switch && self.commomButtons.Print.IsAutoRedirect) {
                                                self.printForm(self.commomButtons.Print);
                                            }

                                            //如果是流程的处理方案
                                            if(payload.IsFlow){
                                                //下个节点负责人
                                                if(payload.IsNextNodePIC){
                                                    self.requestCurrentNodeId = payload.NextNodeId;
                                                    self.requestOperation = "Edit";
                                                    self.requestContentItemId = payload.ContentItemId;
                                                    self.initState = self.initState + 1;
                                                    self.remoteInit(false, payload.NextNodeId);
                                                }
                                                else{
                                                    self.isForceDisplay = true;
                                                    self.emitParent(operater, ResponseCode.Success, x.Result);
                                                }
                                            }
                                            //不是流程
                                            else{
                                                self.isForceDisplay = true;
                                                self.emitParent(operater, ResponseCode.Success, x.Result);
                                            }
                                        })
                                        .catch(x=>{
                                            console.log(x);
                                            self.submitError(operater, {}, x.Code);
                                    });
                                }
                        }).catch(x=> {
                            console.log(x);
                            self.submitError(operater, x, ResponseCode.Error);
                        })
                    }
                    else{
                        self.submitError(operater, {}, ResponseCode.Error);
                    }
                } 
                else {
                    ElMessage.error({
                        message:"当前包含不规范的数据，请仔细检查表单并修改后重新提交",
                        grouping:true
                    });
                    self.submitError(operater, errorFields, ResponseCode.Error);
                }
            });
        },

        //暂存
        draftForm:function(){
            let operater = FormEvent.draft;
            let self = this;
            this.buttonLoading[operater] = true;
            self.beforeSubmitHook(operater).then(
                x=>{
                    if (self.isPropMode) {
                        self.emitParent(operater, ResponseCode.Success, self.formData);
                        self.buttonLoading[operater] = false;
                    }
                    else{
                        self.remoteSubmit(operater)
                            .then(x=>{
                                if(x.Code == ResponseCode.Success){
                                    let operatorName = "暂存";
                                    let alertOption = {
                                        "customClass":"QweSuccessMessage",
                                        "icon": markRaw(Check),
                                        "message":operatorName + "成功"
                                    };
                                    if(!self.$store.state.isPhone){
                                        alertOption = {
                                            "message":operatorName + "成功"
                                        }
                                    }
                                    ElMessage.success(alertOption);
                                }
                                if(x.Code == ResponseCode.SuccessAndWarn){
                                    ElMessage.warning("暂存成功，系统操作遇到一些可以忽略的错误");
                                }
                                let payload = x.Result;
                                self.emitParent(operater, ResponseCode.Success, x.Result);
                                self.buttonLoading[operater] = false;
                                self.requestCurrentNodeId = payload.NextNodeId;
                                self.requestOperation = "Edit";
                                self.requestContentItemId = payload.ContentItemId;
                            })
                            .catch(x=>{
                                console.log(x);
                                self.submitError(operater, {}, x.Code);
                        });
                    }
                }
            ).catch(x=> { 
                console.log(x);
                self.submitError(operater, x, ResponseCode.Error);
            })
        },

        //撤回
        reCallForm:function(){
            this.buttonLoading.draft = true;
            let self = this;
            setTimeout(function(){
                self.buttonLoading.draft = false;
            },3000)
        },

        backOffForm:function(){
            if(this.commomButtons.BackOff.IsDirect){
                this.buttonLoading.BackOff = true;
                this.backOff(FormEvent.backOffToLast);
            }
            else{
                this.backOffModalDisplay = true;
            }
        },

        //退回模态框
        bcakOffModal:function(){
            this.buttonLoading.BackOff = true;
            this.backOff(FormEvent.backOff);
        },

        //退回提交
        backOff:function(operater){
            let self = this;
            self.beforeSubmitHook(operater).then(
                x=>{
                    if (self.isPropMode) {
                        self.emitParent(operater, ResponseCode.Success, self.formData);
                        self.buttonLoading.BackOff = false;
                        self.backOffModalDisplay = false;
                    }
                    else{
                        self.remoteSubmit(operater)
                            .then(x=>{
                                if(x.Code == ResponseCode.Success){
                                    ElMessage.success({
                                        "customClass":"QweSuccessMessage",
                                        "icon": markRaw(Check),
                                        "message":"回退成功"
                                    });
                                }
                                if(x.Code == ResponseCode.SuccessAndWarn){
                                    ElMessage.warning("回退成功，系统操作遇到一些可以忽略的错误");
                                }
                                self.emitParent(operater, ResponseCode.Success, x.Result);
                                self.buttonLoading.BackOff = false;
                                self.backOffModalDisplay = false;
                            })
                            .catch(x=>{
                                console.log(x);
                                self.buttonLoading.BackOff = false;
                                self.backOffModalDisplay = false;
                                self.submitError(operater, {}, x.Code);
                        });
                    }
                }
            ).catch(x=> { 
                console.log(x);
                self.submitError(operater, x, ResponseCode.Error);
            })
        },

        //预览
        previewForm:function(button){
            let url = "/api/Preview/" + button.CorrelationId;
            var data = {};
            (Object.keys(this.formData) || []).forEach(x=>{
                let valueObj = {
                    "Value": this.formData[x]
                };
                data[x] = valueObj;
            })
            let requestData = {
                "Data" : JSON.stringify(data),
                "ContentItemId":this.requestContentItemId
            };
            mockFormSubmit(url,requestData);
        },

        //打印
        printForm:function(button){
            let url = "/api/Print/" + button.CorrelationId;
            let requestData = {
                "DataId" : this.requestContentItemId
            };
            mockFormSubmit(url,requestData);
        },

        //提交前处理
        beforeSubmitHook:function(operater){
            if(this.beforeSubmit != undefined && Object.prototype.toString.call(this.beforeSubmit) == "[object Function]")
            {
                return this.beforeSubmit(this, operater);
            }
            else{
                return Promise.resolve()
            }
        },

        //远程提交
        remoteSubmit:function(operater){
            let formData = new FormData(document.getElementById(this.refForm));
            let subForms = document.getElementById(this.refForm).getElementsByTagName("form");
            let hasOneForms = Array.from(subForms).filter(x=> x.dataset.name == "hasOneFieldForm");
            
            let requestData = {};
            formData.forEach((value,key)=>{
                requestData[key] = value;
            });
            if(hasOneForms.length > 0){
                hasOneForms.forEach(hasOneForm =>{
                    let formData = new FormData(hasOneForm);
                    formData.forEach((value,key)=>{
                        requestData[key] = value;
                    })
                })
            }
            requestData["Submit"] = operater;
            if(this.isCreateMode){
                return createContentItem(this.requestContentType, requestData)
            }
            else{
                if(this.isFlow){ 
                    return updateContentItem(this.requestContentItemId, requestData, this.requestCurrentNodeId)
                }
                else{
                    return updateContentItem(this.requestContentItemId, requestData)
                }
            }
        },

        //前端校验
        checkInResult:function(){
            let errors = new Array;
            (this.checkIn || []).forEach(x=>{
                if (!this.checkInPassItem(x)) {
                    errors.push({"ErrorResume":"校验出错","ErrorMessage":x.Notice});
                }
            })
            if(errors.length > 0){
                let result = {
                    "ErrorMessages": errors
                };
                this.$store.commit("SetErrorState",result);
            }
            return errors.length == 0;
        },

        //单个检验
        checkInPassItem:function(x){
            let context = this.buildContext();
            let func = new Function("Context","Content", x.JsScript);
            return func(context, context.Content);
        },

        //异常处理
        submitError:function(formSubmitEvent, errorFields, code){
            this.buttonLoading[formSubmitEvent] = false;
            if(Object.prototype.toString.call(errorFields) == '[object Object]'){
                let wantScroller = Object.keys(errorFields).length > 0;

                if(wantScroller){
                    let errorFirstField = Object.keys(errorFields)[0];
                    let formInstance = this.$refs.refForm;
                    
                    let path = this.findNodeByChildren([], this.orginalLayout, errorFirstField);
                    let handlerComponents = [];
                    for(let i=0;i<path.length;){
                        let current = path[i];
                        if(current.Type == "Custom"){
                            handlerComponents.push({"Field":current.Name,"Active":current.Name, "IsLayout": false});
                            i++;
                        }
                        else if(current.Type == "NoCustom"){
                            let next = path[i + 1];
                            if(next.Type== "Active"){
                                handlerComponents.push({"Field":current.Name,"Active":next.Name, "IsLayout": true});
                                i = i+2;
                            }   
                        }
                    }

                    this.errorFieldPath = handlerComponents;
                    this.errorEventBus = this.errorEventBus + 1; 
                    setTimeout(()=>{
                        formInstance.scrollToField(errorFirstField);
                    }, 100);
                    //formInstance.scrollToField(errorFirstField);
                    this.wantScroller = errorFirstField;
                    
                }
            }
            
            this.emitParent(formSubmitEvent, code);
        },

        findNodeByChildren:function(path, list, targetName){
            let index = list.findIndex(x => x.Name == targetName);
            if(index > -1){
                return [...path, { "Name":targetName, "Type":"Custom" }];
            }
            else{
                for(let i = 0; i < list.length; i++){
                    let current = list[i];
                    let currentPath = [...path, { "Name":current.Name, "Type": current.FieldDefinition.Name == "Custom" ? "Custom" : "NoCustom" } ];
                    if(current.FieldDefinition.Name == "Custom"){
                        if(current.Name == targetName){
                            return currentPath;
                        }
                    }
                    else{
                        let childList = current.Settings.Childrens;
                        for(let j = 0; j < childList.length; j++){
                            let currentListItem = childList[j];
                            let currentListPath = [...currentPath, { "Name":currentListItem.Title, "Type":"Active" } ];
                            const childPath = this.findNodeByChildren(currentListPath, currentListItem.Components, targetName);
                            if(childPath){
                                return childPath;
                            }
                        }
                    }
                }
            }
        },

        //构建formContext
        buildContext:function(){
            return { 
                Content:this.formData,
                UserInfo:this.$store.state.userInfo,
                Properties:{
                    Env:"From",
                    ParentData:this.qweParent,
                    IsFlow:this.isFlow,
                    Action:this.requestOperation,
                    ContentItemId:this.requestContentItemId,
                    ContentType:this.requestContentType,
                    CurrentNodeId:this.requestCurrentNodeId
                }
            }; 
        },

        //初始化数据
        initFieldData:function(fieldType, fieldName, data, value){
            var orginalValue = data[fieldName];
            switch(fieldType){
                case "AttchFileField":
                case "ImageField":
                    break;
                case "ComputedObjectField":
                    orginalValue = orginalValue || {};

                    break;
                case "ContentPickerField":
                case "DepartField":
                case "MultChoiceProField":
                case "UserField":
                    orginalValue = orginalValue || [];
                    if(!qweEquals.arrayEqual(orginalValue, value)){
                        data[fieldName] = value;
                    }
                    break;
                case "DateField":
                    value = new Date(value);
                    if(!qweEquals.dateEqual(orginalValue, value)){
                        data[fieldName] = value;
                    }
                    break;
                case "PositionField":
                    if(JSON.stringify(orginalValue) != JSON.stringify(value)){
                        data[fieldName] = value;
                    }
                    break;
                case "SubFormField":
                    break;
                
            }
        }
    }
}